<template>
  <div class="">
    <category-layout>
      <section class="about-item-area">
        <div class="container">
          <div class="bg-white pt-20 pb-20">
            <div class="row">
              <div class="col-md-12 left-sidebar mb-20">
                <!-- 添加容器包裹图片和菜单 -->
                <div class="menu-container">
                  <img src="@/assets/images/page/tab.png" alt="" class="menu-image" />
                  <el-menu 
                    :default-active="activeMenu" 
                    mode="vertical"
                    background-color="#f5f7fa"
                    text-color="#303133"
                    active-text-color="#409EFF"
                    @select="handleSelect"
                    class="menu-width"
                  >
                    <el-menu-item index="">全部信息</el-menu-item>
                    <el-menu-item index="registration">进行中</el-menu-item>
                    <el-menu-item index="finished">已结项</el-menu-item>
                  </el-menu>
                </div>
              </div>
              
              <!-- 右侧区域同步调整 -->
              <div class="col-md-12 right-content">
                <div class="search-container">
                  <div class="search-header-bg"></div>
                  <div class="search-row">
                    <div class="search-group">
                      <span class="search-label pl-20 pr-20">关键字</span>
                      <el-input 
                        placeholder="请输入搜索关键字" 
                        v-model="searchKeyword" 
                        class="search-input"
                        @keyup.enter.native="handleSearch"
                        clearable
                        @clear="handleSearch"
                      >
                      </el-input>
                    </div>

                    <el-button 
                      type="primary" 
                      class="search-button" 
                      @click="handleSearch"
                      icon="el-icon-search"
                    >查询</el-button>
                  </div>
                </div>               

                <div class="about-tab-btn" v-loading="isLoading">
                  <div class="about-post-items">
                    <div class="row">
                      <div class="col-lg-12" v-if="events.length">
                        <template v-for="(small, index) in events">
                          <row-card
                            :class="[darkClass && 'item' in darkClass ? darkClass.item : '']"
                            :category="true"
                            :smalldatas="small"
                            :key="index"
                            :type="type"
                            :checkCuid="true"
                          />
                        </template>
                      </div>

                      <div v-else-if="!isLoading">
                        <div class="col-lg-12">
                          <div class="error-thumb text-center">
                            <img src="@/assets/images/empty.jpg" alt="" />
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-12 mt-20">
                        <div v-if="totalPages > 1" class="pagination-item">
                          <nav aria-label="Page navigation example">
                            <ul class="pagination">
                              <!-- 上一页按钮 -->
                              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                <a class="page-link" @click="changePage(currentPage - 1)" href="#" aria-label="Previous">
                                  <span aria-hidden="true"><i class="fas fa-caret-left"></i></span>
                                </a>
                              </li>
                              <!-- 页码按钮 -->
                              <li 
                                v-for="page in visiblePages" 
                                :key="page" 
                                class="page-item" 
                                :class="{ active: page === currentPage }"
                              >
                                <a class="page-link" @click="changePage(page)" href="#">{{ page }}</a>
                              </li>
                              <!-- 下一页按钮 -->
                              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                <a class="page-link" @click="changePage(currentPage + 1)" href="#" aria-label="Next">
                                  <span aria-hidden="true"><i class="fas fa-caret-right"></i></span>
                                </a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <floating-buttons />

        </div>
      </section>
    </category-layout>
  </div>
</template>

<style scoped>
.three-line-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; /* 显示三行 */
}

/* 添加菜单宽度控制样式 */
.menu-container {
  display: inline-block;
  width: fit-content;
}

.menu-image {
  width: 100%;
  height: auto;
}

.menu-width {
  width: 100%;
  border: none; /* 可选：移除默认边框 */
  margin-top: 5px;
}

/* 新增：菜单选中状态样式 */
::v-deep .el-menu-item.is-active {
  background-image: url('~@/assets/images/page/tab_bg.png'); /* 添加~前缀修复路径解析问题 */
  background-size: cover;
  background-repeat: no-repeat;
  color: #ffffff !important;
}

/* 搜索区域样式 */
/* 修改搜索容器样式，添加背景图 */
.search-container {
  width: 100%;
  background-color: #eff0f2; /* 设置背景色 */
  padding: 0; /* 移除内边距，避免影响图片显示 */
}

/* 新增：搜索区域头部图片样式 */
.search-header-img {
  width: 100%; /* 宽度与搜索区域一致 */
  height: auto;
  display: block; /* 确保图片正确显示 */
}

/* 搜索按钮样式 */
.search-button {
  margin-left: 10px;
  min-width: 80px;
}

/* 调整搜索行样式，确保元素正确排列 */
.search-row {
  display: flex;
  gap: 10px;
  padding: 10px;
  align-items: center;
  flex-wrap: nowrap; /* 防止元素换行 */
}

/* 调整搜索行样式，添加内边距 */
.search-row {
  display: flex;
  gap: 10px;
  padding: 10px; /* 原有内边距移至此处 */
  align-items: center;
}

/* 新增：搜索标签样式 */
.search-label {
  white-space: nowrap;
  color: #303133;
  font-size: 14px;
}

.search-select {
  flex: 1;
}

.search-input {
  flex: 2;
}

/* 新增：搜索区域顶部背景样式 */
.search-header-bg {
  height: 8px;
  width: 100%;
  background-image: url('~@/assets/images/page/header_bg.png');
  background-repeat: repeat-x; /* 水平重复显示 */
  background-size: auto 100%; /* 保持图片原有宽度，高度适应容器 */
}

/* 自定义左侧区域宽度 - 在大屏幕下生效 */
@media (min-width: 992px) {
  .left-sidebar {
    flex: 0 0 22%; /* 可根据需要调整此百分比（建议20%-24%之间） */
    max-width: 22%;
  }
  .right-content {
    flex: 0 0 78%; /* 右侧宽度自动适配（100% - 左侧宽度） */
    max-width: 78%;
  }
}

/* 修改移动端搜索区域适配 */
@media (max-width: 768px) {
  /* 允许搜索元素换行 - 修改为块级显示 */
  .search-row {
    display: block; /* 将flex改为block */
    padding: 15px 10px;
  }
  
  /* 修改搜索组容器 - 实现各占一列布局 */
  .search-group {
    width: 100%; /* 每个搜索组占满整行 */
    margin-bottom: 15px; /* 增加组之间的垂直间距 */
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
  }
  
  /* 搜索标签样式 */
  .search-group .search-label {
    flex: 0 0 auto;
    text-align: left;
    padding-right: 0;
    white-space: nowrap;
  }
  
  .search-select, .search-input {
    flex: 1;
    min-width: 0;
  }
  
  /* 搜索按钮在移动端占满整行 */
  .search-button {
    width: 100%;
    margin-left: 0;
    padding: 12px 0;
  }
  
  /* 调整搜索容器边距 */
  .search-container {
    margin-bottom: 20px; /* 减少底部间距 */
  }
}

/* 调整搜索组样式，确保标签和输入框在同一行 */
.search-group {
  flex: 1; /* 让搜索组在搜索行中分配空间 */
  display: flex;
  align-items: center;
  gap: 8px; /* 标签和输入框间距 */
}

/* 搜索标签样式优化 */
.search-label {
  white-space: nowrap;
  color: #303133;
  font-size: 14px;
  flex: 0 0 auto; /* 标签不伸缩 */
}

/* 搜索输入框样式调整 */
.search-input {
  flex: 1; /* 输入框占据剩余空间 */
}

/* 搜索选择框样式调整 */
.search-select {
  flex: 1; /* 选择框占据剩余空间 */
}
</style>

<script>
import CategoryLayout from "@/components/Events/CategoryLayout.vue";
import RowCard from "@/components/Utility/Cards/RowCard.vue";
import FloatingButtons from "@/components/Common/FloatingButtons.vue";
import { 
  getEvents,
  getEventSettings 
} from "@/api/event";
import { getMeManuscripts } from '@/api/user';
import { formatTimestampToDateTime } from '@/utils/dateUtil';
import { eventBus } from '@/utils/eventBus.js';

export default {
  components: { CategoryLayout, RowCard, FloatingButtons },
  inject: ['dataWrapper', 'fetchStatus'],
  data() {
    return {
      phase:'',
      isLoading: true,
      activeMenu: '1',
      searchKeyword: '',
      darkClass: {}, 
      selectedStatus: '',
      posts: [],
      events: [],
      keyword: this.$route.query.keyword || '',
      type: Number(this.$route.query.type) || 0,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      maxVisiblePages: 5,
    };
  },
  watch: {
    '$route.query.keyword': {
      handler(newKeyword) {
        this.keyword = newKeyword;
      },
      immediate: true
    },
    '$route.query.type': {
      handler(newType) {
        this.type = Number(newType) || 0;
      },
      immediate: true
    }
  },
  methods: {
    async fetchEvents() {
      try {
        const filter = {};
        if (this.type) {
          filter.type = this.type;
        }
        if (this.keyword) {
          filter.keyword = this.keyword;
        }
        if (this.phase) {
          filter.phase = this.phase;
        }
        
        // 检查是否有token（根据实际项目的token存储方式调整）
        const token = localStorage.getItem('token');
        // 根据token是否存在决定是否调用getMeManuscripts
        const manuscriptsPromise = token ? getMeManuscripts() : Promise.resolve(null);
        
        // 同时调用两个接口（如果有token则调用getMeManuscripts）
        const [eventsResponse, manuscriptsResponse] = await Promise.all([
          getEvents({ filter }, (this.currentPage - 1) * this.pageSize, this.pageSize),
          manuscriptsPromise
        ]);
        
        // 处理events接口数据
        if (eventsResponse && eventsResponse.list) {
          this.total = eventsResponse.data.pagination.total;

          let events = eventsResponse.list;
          
          // 如果有事件，获取所有事件的设置
          if (events.length > 0) {
            const settingsPromises = events.map(event => 
              getEventSettings(event.id).catch(error => {
                console.log(`获取事件${event.id}设置失败:`, error);
                return null;
              })
            );

            // 等待所有设置请求完成
            const settingsResults = await Promise.all(settingsPromises);
            
            // 合并设置到事件数据中
            events = events.map((event, index) => ({
              ...event,
              settings: settingsResults[index]?.data?.rules?.[0] ?? {}
            }));
            this.events = events;
          }
          this.isLoading = false;
        } else {
          // console.error('events响应数据格式不正确');
        }

        // 处理用户参与项目接口数据并进行比对
        if (manuscriptsResponse && manuscriptsResponse.code === 200 && manuscriptsResponse.data) {
          // 获取用户参与的项目ID集合
          const userEventIds = manuscriptsResponse.data.events 
            ? Object.values(manuscriptsResponse.data.events).map(event => event.id)  // 使用Object.values转换对象为数组
            : [];
            
          // 标记用户参与的项目
          this.events = this.events.map(event => {
            const isParticipated = userEventIds.includes(event.id);
            const manuscript = isParticipated ? manuscriptsResponse.list.find(manu => manu.eventid === event.id) : null;
            
            return {
              ...event,
              isParticipated,
              manuscriptid: manuscript?.id || null,
              manuscript: manuscript,
            };
          });

        } else {
          // 有token但接口调用失败的情况
          // console.error('getMeManuscripts响应数据格式不正确');
        }
        // 无token时不处理用户参与项目逻辑
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },
    // 切换页码的方法
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchEvents();
      }
    },
    // 重置分页信息
    resetPagination() {
      this.currentPage = 1;
    },
    handleSearch() {
      const keyword = this.searchKeyword.trim();
      this.keyword = keyword;
      this.resetPagination();
      this.fetchEvents();
    },
    handleSelect(key) {
      this.activeMenu = key;
      if (this.activeMenu == 'registration' || this.activeMenu == 'finished'){
        this.phase = this.activeMenu;
      } else {
        this.phase = '';
      }
      this.fetchEvents();
    },
    formatTimestampToDateTime
  },
  created() {
    this.fetchEvents();
    eventBus.$on('userLoggedIn', this.fetchEvents);
    eventBus.$on('userLoggedOut', this.fetchEvents);
  },
  computed: {
    // 计算总页数
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
    // 计算可见的页码
    visiblePages() {
      const startPage = Math.max(1, this.currentPage - Math.floor(this.maxVisiblePages / 2));
      const endPage = Math.min(this.totalPages, startPage + this.maxVisiblePages - 1);
      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
    }
  },
  beforeDestroy() {
    eventBus.$off('userLoggedIn', this.fetchEvents);
    eventBus.$off('userLoggedOut', this.fetchEvents);
  }
};
</script>